import { Injectable, inject } from '@angular/core';

import { MarqueeIndexedFixtureView } from '@cds/betting-offer/domain-specific';
import { MarqueeRequest } from '@cds/query-objects';
import { BaseCdsApi, BaseCdsApiFactory, CDS_API_FACTORY } from '@frontend/sports/content-distribution/feature';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MarqueeApi {
    private cdsApi: BaseCdsApi;

    constructor() {
        const cdsApiServiceFactory = inject<BaseCdsApiFactory>(CDS_API_FACTORY);

        this.cdsApi = cdsApiServiceFactory({ endpoint: '/marquee' });
    }

    getMarquees(request: MarqueeRequest): Observable<MarqueeIndexedFixtureView[] | undefined> {
        return this.cdsApi.post<MarqueeIndexedFixtureView[]>(`/fixtures`, request);
    }
}
